import { CostReviewLine } from './cost-review-line';
import { FormattedCurrencyContainer } from '../../../components/formatted-currency/container';

/**
 * @param {object} props
 * @param {string|object} props.serviceName
 * @param {number} props.serviceCost
 * @param {string} [props.serviceCurrencyCode]
 * @returns {React.JSX.Element}
 */
export const CostReviewLineItemService = ({ serviceName = '', serviceCost = 0.0, serviceCurrencyCode = null }) => {
  return (
    <CostReviewLine>
      <div>{serviceName}</div>
      <div>
        <FormattedCurrencyContainer currencyCode={serviceCurrencyCode} value={serviceCost} />
      </div>
    </CostReviewLine>
  );
};
